import {
  Badge,
  Box,
  Card,
  CardBody,
  CardHeader,
  CircularProgress,
  Heading,
  HStack,
  Link,
  LinkBox,
  LinkOverlay,
  Spinner,
  Stack,
  StackDivider,
  Tag,
  Text,
  Button
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { apiEndPoint } from "./StaticVar";
import NoFeeds from "./NoFeeds";
import MyLoading from "./MyLoading";

function Feeds() {
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    getPosts();
  }, []);

  const getPosts = async () => {
    const response = await fetch(apiEndPoint + "/api/posts");
    const json = await response.json();
    setPosts(json);
    console.log(json);
    setLoading(false);
  };

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const handleFilter = (month, year) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    refetchPosts(month, year);
  };

  const refetchPosts = async (month, year) => {
    setLoading(true);
    const response = await fetch(`${apiEndPoint}/api/posts?month=${month}&year=${year}`);
    const json = await response.json();
    setPosts(json);
    setLoading(false);
  };

  return (
    <Stack>
      <HStack spacing={4} gap={4} mb={4} m={2} overflowX="scroll">
        {Array.from({ length: 36 }, (_, i) => {
          const month = new Date().getMonth() + 1 - i;
          const year = new Date().getFullYear() - Math.floor((12 - month) / 12);
          const adjustedMonth = ((month - 1 + 12) % 12) + 1;
          return (
            <Badge
              className="btn"
              key={`${year}-${adjustedMonth}`}
              color={"white"}
              borderRadius={8}
              background={
                adjustedMonth === selectedMonth && year === selectedYear ? "#000081" : "lightgray"
              }
              cursor="pointer"
              onClick={() => {
                handleFilter(month, year);
              }}
              fontSize="md"
              p={2}
            >
              {new Date(0, adjustedMonth - 1).toLocaleString("default", { month: "short" })}-{year % 100}
            </Badge>
          );
        })}
      </HStack>
      {loading ? (
        <MyLoading />
      ) : (posts.length > 0 ?
        Object.keys(posts).map((k) => {
          return (
            <LinkBox as="article" p="5" borderWidth="1px" rounded="md" key={posts[k]["id"]}>
              <span asChild color="fg.muted" textStyle="sm">
                <time>{new Date(posts[k]["created_on"]).toDateString()}</time>
              </span>
              <Heading size="md" my="2">
                <LinkOverlay href={"/feed/" + posts[k]["id"] + "/" + encodeURIComponent(posts[k]["title"])}>{posts[k]["title"]}</LinkOverlay>
              </Heading>
              <Text mb="3" color="fg.muted">
                {posts[k]["content"]}
              </Text>
              <Link
                href={apiEndPoint + "/" + posts[k]["pdf_url"]}
                isExternal
                variant="underline"
                color="teal"
              >
                View PDF
              </Link>
              <HStack spacing={2} pt={2}>
                {posts[k]["tags"].split(",").map((tag, index) => (
                  <Tag key={index}>{tag.toUpperCase()}</Tag>
                ))}
              </HStack>
            </LinkBox>
          );
        }) : <NoFeeds month={selectedMonth} year={selectedYear}/>
      )}
    </Stack>
  );
}

export default Feeds;
